import { promises as fs } from 'fs';
import path from 'path';
import { fileURLToPath } from 'url';
import type { WorkOSTools } from './types.js';

const DOCS_OUTPUT_DIR = '.docs/organized';
const REMOTE_BASE_URL = 'https://static.workos.dev';

// Get the directory where this module is located (the MCP server directory)
const __filename = fileURLToPath(import.meta.url);
const __dirname = path.dirname(__filename);
const SERVER_ROOT = path.resolve(__dirname, '..');

async function pathExists(path: string): Promise<boolean> {
  try {
    await fs.access(path);
    return true;
  } catch {
    return false;
  }
}

export async function getTools(): Promise<WorkOSTools> {
  const docsPath = path.join(SERVER_ROOT, DOCS_OUTPUT_DIR, 'docs');
  const examplesPath = path.join(SERVER_ROOT, DOCS_OUTPUT_DIR, 'examples');
  const changelogsPath = path.join(SERVER_ROOT, DOCS_OUTPUT_DIR, 'changelogs');

  // Check if organized docs exist locally
  const hasLocalDocs = await pathExists(docsPath);
  const hasLocalExamples = await pathExists(examplesPath);
  const hasLocalChangelogs = await pathExists(changelogsPath);

  return {
    docs: {
      type: 'DocumentationTool',
      name: 'WorkOS SDK Docs',
      instructions: 'Use these to answer developer questions about integrating WorkOS.',
      docsPath: hasLocalDocs ? docsPath : `${REMOTE_BASE_URL}/docs/index.md`,
    },
    examples: {
      type: 'ExamplesTool',
      examplesPath: hasLocalExamples ? examplesPath : `${REMOTE_BASE_URL}/examples`,
    },
    changelogs: {
      type: 'ChangeLogTool',
      changelogsPath: hasLocalChangelogs ? changelogsPath : `${REMOTE_BASE_URL}/changelogs`,
    },
  };
}
